import { createReducer, on } from '@ngrx/store';
import { stockHistoryActions } from '../actions/stock-history.actions';
import { StockHistoryEntry, StockHistoryMode } from '../models';

export interface StockHistoryState {
    mode: StockHistoryMode | null;
    loaded: boolean | null;
    loading: boolean;
    entries: StockHistoryEntry[];
    total: number;
}

export const initialState: StockHistoryState = {
    mode: null,
    loaded: null,
    loading: false,
    entries: [],
    total: 0,
};

export const stockHistoryReducer = createReducer(
    initialState,
    // Both views share the store: the other view's rows must not show while this one loads, so a mode switch starts over.
    on(stockHistoryActions.getHistory, (state, { mode }): StockHistoryState => ({
        ...(state.mode === mode ? state : initialState),
        mode,
        loading: true,
    })),
    on(stockHistoryActions.getHistorySuccess, (state, { payload }): StockHistoryState => ({
        ...state,
        loading: false,
        loaded: true,
        entries: payload.items,
        total: payload.total,
    })),
    on(stockHistoryActions.getHistoryError, (state): StockHistoryState => ({
        ...state,
        loading: false,
        loaded: false,
    })),
    on(stockHistoryActions.clear, (): StockHistoryState => ({ ...initialState })),
);
